export const HIGH_OVERLOAD_MESSAGE =
  'Z naszą popularnością idą też problemy - nasze serwery potrzebują chwili wytchnienia. Nie martw się, wiemy o problemie, odpocznij i spróbuj ponownie za chwilę.';

export const HIGH_OVERLOAD_TIMEOUT = 30000;
